import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Box, Skeleton, styled, Typography } from '@mui/material';
import useShopifyProductSWR from '../../../../hooks/shopify/useShopifyProductSWR';
import { ProductImagesView } from '../../../product/ProductImages';
import { ProductDetails } from '../../../product/ProductDetails';
import { ProductPrices } from '../../../product/ProductPrices';
import { ProductAddTo } from '../../../product/ProductAddTo';
import { Breadcrumb } from '../../../product/Breadcrumb';
import { ProductTabDetails } from '../../../product/ProductTabDetails';
import { ProductStockStatus } from '../../../product/ProductStockStatus';
import { ProductUnitDetails } from '../../../product/ProductUnitDetails';

const StyledTitle = styled(Typography)(({ theme }) => ({
    fontSize: '20px',
    color: '#232323',
    fontWeight: 600,
}));

const StyledBox = styled(Box)(({ theme }) => ({
    flex: '0 0 50%',
    [theme.breakpoints.down('sm')]: {
        flex: '0 0 100%',
    },
}));

const ProductContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
    },
}));

const PageContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
}));

export const ProductPage: React.FC = () => {
    const { t } = useTranslation();
    const { productHandle } = useParams();

    const { product, isLoading, isError, forceRefresh } =
        useShopifyProductSWR(productHandle);

    const [selectedVariant, setSelectedVariant] = useState(null);

    const loadingPageMarkup = (
        <>
            <Box sx={{ width: '50%' }}>
                <Skeleton
                    variant="rectangular"
                    sx={{ width: '100%' }}
                    height={200}
                />
            </Box>
            <Box sx={{ width: '100%', paddingLeft: '20px' }}>
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            </Box>
        </>
    );

    if (isLoading) {
        return loadingPageMarkup;
    }
    if (isError) {
        return (
            <Typography paragraph>
                {t('COLLECTIONS.REQUEST_ERROR').toString()}
            </Typography>
        );
    }

    return (
        <PageContainer>
            <Breadcrumb />
            <ProductContainer>
                <StyledBox>
                    <ProductImagesView images={product.images.nodes} />
                </StyledBox>
                <StyledBox>
                    <StyledTitle variant="h1" gutterBottom>
                        {product.title}
                    </StyledTitle>
                    <ProductStockStatus
                        product={product}
                        variant={
                            selectedVariant
                                ? selectedVariant
                                : product.variants.nodes[0]
                        }
                    />
                    <ProductDetails
                        product={product}
                        variant={
                            selectedVariant
                                ? selectedVariant
                                : product.variants.nodes[0]
                        }
                    />
                    <ProductPrices
                        variant={
                            selectedVariant
                                ? selectedVariant
                                : product.variants.nodes[0]
                        }
                    />
                    {/*<ProductUnitDetails*/}
                    {/*    variant={*/}
                    {/*        selectedVariant*/}
                    {/*            ? selectedVariant*/}
                    {/*            : product.variants.nodes[0]*/}
                    {/*    }*/}
                    {/*/>*/}
                    <ProductAddTo
                        variant={
                            selectedVariant
                                ? selectedVariant
                                : product.variants.nodes[0]
                        }
                    />
                </StyledBox>
            </ProductContainer>
            <ProductTabDetails product={product} />
        </PageContainer>
    );
};
